export function isLegacyThemeId(value) {
    return value === 'win98' || value === 'tfi-friday' || value === 'black-yellow';
}
export function defineTheme(theme) {
    if (!/^[a-z][a-z0-9-]*$/.test(theme.id) || !theme.displayName.trim()) {
        throw new Error('Theme identity is invalid.');
    }
    if (theme.selectable && theme.lifecycle !== 'ready') {
        throw new Error(`Theme ${theme.id} is not ready for production selection.`);
    }
    if ((theme.implementation === 'legacy') !== isLegacyThemeId(theme.id)) {
        throw new Error(`Theme ${theme.id} cannot enter or redefine the legacy boundary.`);
    }
    Object.freeze(theme.capabilities);
    return Object.freeze(theme);
}
//# sourceMappingURL=contracts.js.map